import { AnimatePresence, motion } from 'motion/react';

import { t } from '@/shared/i18n';
import { springs } from '@/shared/lib/motion';
import type { Presence } from '@/shared/realtime';
import { Avatar } from '@/shared/ui/Avatar';
import { Tooltip } from '@/shared/ui/Tooltip';

import styles from './AvatarStack.module.scss';

/**
 * Стопка аватаров с наложением: кто сейчас в записи. Появление и уход —
 * пружиной, в подсказке имя и что человек делает.
 */
export function AvatarStack({
  people,
  fieldName,
  max = 5,
}: {
  people: Presence[];
  /** Название поля по ключу — для подсказки «правит „Заголовок“». */
  fieldName: (key: string) => string;
  max?: number;
}) {
  const shown = people.slice(0, max);
  const rest = people.length - shown.length;

  return (
    <span className={styles['stack']}>
      <AnimatePresence initial={false}>
        {shown.map((person) => {
          const name = person.support ? `${person.name} (${t.live.support})` : person.name;
          const hint =
            person.field === undefined
              ? t.live.viewing(name)
              : t.live.editingField(name, fieldName(person.field));

          return (
            <motion.span
              key={person.user_id}
              layout
              className={styles['stack__item']}
              initial={{ scale: 0.4, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.4, opacity: 0 }}
              transition={springs.rubber}
            >
              <Tooltip content={hint}>
                <span>
                  <Avatar name={person.name} size="xs" online />
                </span>
              </Tooltip>
            </motion.span>
          );
        })}
      </AnimatePresence>
      {rest > 0 && <span className={styles['stack__more']}>+{rest}</span>}
    </span>
  );
}
